import cn from 'classnames';
import React, {useState} from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import Popup from '../../../components/Popup/Popup';
import appConfig from '../../../config/appConfig';
import logState from '../../../services/logger/logState';
import {dispatch} from '../../../state//store';
import {showConsumerFeedbackGatheringModalAction} from '../../../state/ducks/modal';
import CopyDeviceInfoButton from './CopyDeviceInfoButton';
import styles from './Logs.module.css';

const Logs = () => {
    const [isVisibleLogs, setIsVisibleLogs] = useState(false);
    const [logs, setLogs] = useState(null);

    const onLogsOpen = () => {
        if (appConfig.getIsLogsVisible()) {
            setLogs(logState.getLogState());
            setIsVisibleLogs(true);
        }
    };
    const onLogsClose = () => setIsVisibleLogs(false);

    const clearLogs = () => {
        setLogs(null);
        logState.clearLogState();
        onLogsClose();
    };

    const title = appConfig.getIsAppVersionVisible() ? appConfig.getAppVersion() : 'Logs';

    const showFeedbackModal = () => {
        dispatch(showConsumerFeedbackGatheringModalAction());
    };

    return (
        <>
            <div id='logs' className={styles.LogsIcon} onClick={onLogsOpen}>
                {title}
            </div>

            {isVisibleLogs && (
                <Popup onClose={onLogsClose} overlayClassName={styles.LogsPopupOverlay} className={styles.LogsPopup}>
                    <div className='flex gap-5'>
                        <div onClick={clearLogs} className={styles.ClearLogsBtn}>
                            Clear logs
                        </div>
                        <CopyToClipboard text={logs?.map(({log}) => log).join('\n')}>
                            <div className={styles.ClearLogsBtn}>Copy logs</div>
                        </CopyToClipboard>
                        <CopyDeviceInfoButton className='ml-auto' />
                    </div>

                    {/* FOR FEEDBACK POPUP TEST ONLY */}
                    <div
                        onClick={showFeedbackModal}
                        className={cn('flex w-48 justify-center bg-tertiary', styles.ClearLogsBtn)}
                    >
                        Feedback Popup
                    </div>
                    {logs?.map(({log}, i) => {
                        return (
                            <div className={styles.LogContainer} key={i}>
                                <div className={styles.Log}>{log}</div>
                            </div>
                        );
                    })}
                </Popup>
            )}
        </>
    );
};

export default Logs;
